import router from '@/router'
import utils from '@/utils/utils.js'

const user = {
  state: {
    token:'',
    userInfo:{},
  },

  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setToken(state, data){
      state.token = data;
    },
    loginOut(state,data){
      state.userInfo = {}
    }
  },
  actions: {
  }
}
export default user
